<template>
  <div>
    <vue-html2pdf
      :show-layout="showLayout"
      :float-layout="floatLayout"
      :preview-modal="previewModal"
      :paginate-elements-by-height="paginateElementsByHeight"
      :filename="filename"
      :pdf-quality="pdfQuality"
      :manual-pagination="manualPagination"
      :pdf-format="pdfFormat"
      :pdf-orientation="pdfOrientation"
      :pdf-content-width="pdfContentWidth"
      :image="{type: 'jpeg', quality: 0.95}"
      @progress="$emit('onProgress', $event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <slot name="content" />
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    VueHtml2pdf,
  },
  props: {
    showLayout: {
      type: Boolean,
      default: false,
    },
    floatLayout: {
      type: Boolean,
      default: false,
    },
    previewModal: {
      type: Boolean,
      default: false,
    },
    paginateElementsByHeight: {
      type: Number,
      default: 1200,
    },
    filename: {
      type: String,
      default: `export-pdf-${new Date().getTime()}`,
    },
    pdfQuality: {
      type: Number,
      default: 2,
    },
    manualPagination: {
      type: Boolean,
      default: false,
    },
    pdfFormat: {
      type: String,
      default: "a4",
    },
    pdfOrientation: {
      type: String,
      default: "portrait",
    },
    pdfContentWidth: {
      type: String,
      default: "100%",
    },
    generatePdf: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    generatePdf(value) {
      if (value) {
        this.$refs.html2Pdf.generatePdf();
      }
    },
  },
};
</script>